class DesktopMegaTabs extends HTMLElement {
  connectedCallback() {
    if (this._controller) return;
    this._controller = new AbortController();
    const { signal } = this._controller;
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-mega-tab]');
      if (tab && this.contains(tab)) this.activate(tab, false);
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (!event.target.matches('[data-mega-tab]')) return;
      const tabs = Array.from(this.querySelectorAll('[data-mega-tab]'));
      const current = tabs.indexOf(event.target);
      let next = current;
      if (event.key === 'ArrowLeft') next = (current + 1) % tabs.length;
      else if (event.key === 'ArrowRight') next = (current - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      this.activate(tabs[next], true);
    }, { signal });
  }

  disconnectedCallback() {
    this._controller?.abort();
    this._controller = null;
  }

  activate(selectedTab, moveFocus) {
    this.querySelectorAll('[data-mega-tab]').forEach((tab) => {
      const selected = tab === selectedTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (moveFocus) selectedTab.focus();
  }
}

if (!customElements.get('desktop-mega-tabs')) {
  customElements.define('desktop-mega-tabs', DesktopMegaTabs);
}
